var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('login',{on:{"done":_vm.onLogin}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }